import { AnalyseConstants } from '../../../_constants';
// import { AnalyseService } from '../../../_services';

export const saveModulePermissionsAction = {
    saveModulePermissionsHandler,
    requestModulePermissionsHandler
}

function saveModulePermissionsHandler(data) {
    return dispatch => {
        // dispatch(request(data));
        dispatch(success(data));
    };

    // function request(data) { return { type: AnalyseConstants.REQUEST_SAVE_TEAM_DETAIL, data } }
    function success(data) { return { type: AnalyseConstants.RECEIVE_SAVE_MODULE_DETAIL, data } }
    // function failure(error) { return { type: AnalyseConstants.SAVE_TEAM_DETAIL_ERROR, error } }
}

function requestModulePermissionsHandler() {
    return dispatch => {
        dispatch(request());
        // dispatch(success(data));
        
    };
    function request() { return { type: AnalyseConstants.REQUEST_SAVE_MODULE_DETAIL } }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyse/saveModulePermissions/saveModulePermissions.action.js